(function () {
  if (window.__customContentVariantHighlightInit) return;
  window.__customContentVariantHighlightInit = true;

  var currentVariantText = '';

  function variantToText(variant) {
    if (!variant) return '';
    return [variant.title, variant.option1, variant.option2, variant.option3].filter(Boolean).join(' ');
  }

  function readInitialVariantText() {
    var picker = document.querySelector('variant-picker');
    var script = picker && picker.querySelector('script[data-selected-variant]');
    if (!script) return '';
    try {
      return variantToText(JSON.parse(script.textContent));
    } catch (e) {
      return '';
    }
  }

  // Match keywords can be a comma-separated list (e.g. one battery capacity
  // that's shared by several motor tiers) - matches if ANY keyword is found.
  function splitKeywords(rawKeyword) {
    return (rawKeyword || '')
      .split(',')
      .map(function (keyword) { return keyword.trim(); })
      .filter(Boolean);
  }

  function textMatchesAnyKeyword(text, keywords) {
    return keywords.some(function (keyword) {
      return text.indexOf(keyword) !== -1;
    });
  }

  function applyHighlight() {
    document.querySelectorAll('[data-variant-highlight]').forEach(function (section) {
      var keywords = splitKeywords(section.getAttribute('data-variant-keyword'));
      var isMatch = keywords.length > 0 && textMatchesAnyKeyword(currentVariantText, keywords);
      section.classList.toggle('is-variant-match', isMatch);
      section.classList.toggle('is-variant-dimmed', !isMatch);
    });
  }

  function pickBestOption(candidates) {
    if (candidates.length <= 1) return candidates[0] || null;
    var currentWords = currentVariantText.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
    var best = candidates[0];
    var bestScore = -1;
    candidates.forEach(function (input) {
      var words = input.value.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
      var score = words.filter(function (word) {
        return currentWords.indexOf(word) !== -1;
      }).length;
      if (score > bestScore) {
        bestScore = score;
        best = input;
      }
    });
    return best;
  }

  function selectVariantOption(rawKeyword) {
    var picker = document.querySelector('variant-picker');
    var keywords = splitKeywords(rawKeyword);
    if (!picker || !keywords.length) return;

    var candidates = Array.prototype.filter.call(
      picker.querySelectorAll('input[type="radio"]'),
      function (input) {
        return textMatchesAnyKeyword(input.value, keywords);
      }
    );
    if (!candidates.length) return;

    var target = pickBestOption(candidates);
    if (!target || target.checked) return;

    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));

    setTimeout(function () {
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 150);
  }

  function bindButtons() {
    document.querySelectorAll('[data-variant-select-btn]').forEach(function (button) {
      if (button.__variantHighlightBound) return;
      button.__variantHighlightBound = true;
      button.addEventListener('click', function () {
        selectVariantOption(button.getAttribute('data-variant-keyword'));
      });
    });
  }

  function init() {
    currentVariantText = readInitialVariantText();
    applyHighlight();
    bindButtons();

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      currentVariantText = variantToText(variant);
      applyHighlight();
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  document.addEventListener('shopify:section:load', function () {
    applyHighlight();
    bindButtons();
  });
})();
